import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/site/Header";
import Hero from "./components/site/Hero";
import Marquee from "./components/site/Marquee";
import ExportMap from "./components/site/ExportMap";
import WhyIndia from "./components/site/WhyIndia";
import Stats from "./components/site/Stats";
import Dedication from "./components/site/Dedication";
import Brands from "./components/site/Brands";
import Categories from "./components/site/Categories";
import Services from "./components/site/Services";
import RxSaaS from "./components/site/RxSaaS";
import HealthFacts from "./components/site/HealthFacts";
import RFQForm from "./components/site/RFQForm";
import MeetingForm from "./components/site/MeetingForm";
import Contact from "./components/site/Contact";
import Footer from "./components/site/Footer";
import WhatsAppFab from "./components/site/WhatsAppFab";
import Admin from "./components/admin/Admin";

const Home = () => (
    <div className="min-h-screen bg-[#FAF9F6] text-ink font-sans">
        <Header />
        <main>
            <Hero />
            <Marquee />
            <ExportMap />
            <WhyIndia />
            <Stats />
            <Dedication />
            <Brands />
            <Categories />
            <Services />
            <RxSaaS />
            <HealthFacts />
            <RFQForm />
            <MeetingForm />
            <Contact />
        </main>
        <Footer />
        <WhatsAppFab />
    </div>
);

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/admin" element={<Admin />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
